import React, { FC } from 'react';
import { usePrivateChat } from '../hooks/usePrvateChat';
import { PrivateChatMessages } from './privateChatMessages/privateChatMessages';
import { PrivateChatFooter } from './privateChatFooter/privateChatFooter';

type PropsType = {
  recipientId: number;
};

export const PrivateChat: FC<PropsType> = ({ recipientId }: PropsType) => {
  const { myMessage, setMyMessage, sendMessage, messages, handleEmoji } = usePrivateChat();

  const privatList = <>{recipientId! >= 0 && messages && <PrivateChatMessages messages={messages} />}</>;
  const footerJSX = recipientId! >= 0 && (
    <PrivateChatFooter
      myMessage={myMessage}
      setMyMessage={setMyMessage}
      sendMessage={sendMessage}
      recipientId={recipientId}
      handleEmoji={handleEmoji}
    />
  );

  return (
    <>
      {privatList}
      {footerJSX}
    </>
  );
};
